import Image from "next/image";
import largeImg from "../../public/assets/goat-spins-banner-desk-welcome-min.jpg";
import mediumImg from "../../public/assets/goat-spins-banner-desk-welcome-min.jpg";
import smallImg from "../../public/assets/goat-spins-banner-mob-welcome-min.jpg";

const ResponsiveHomeImage = () => (
  <picture>
    <source media="(max-width: 520px)" srcSet={smallImg.src} />
    <source
      media="(min-width: 521px) and (max-width: 950px)"
      srcSet={mediumImg.src}
    />
    <source media="(min-width: 951px)" srcSet={largeImg.src} />
    <Image
      src={largeImg.src}
      alt="Responsive Image"
      layout="responsive"
      width={1400}
      height={600}
      priority
      className="responsive-image"
    />
  </picture>
);

export default ResponsiveHomeImage;
